module.exports = __webpack_public_path__ + "static/media/codeFree.06d1a51d.svg";